module.exports = __webpack_public_path__ + "static/media/icon_extension_txt.1b40e8ee.svg";